export const ns = 'cube3/modals';
